import * as React from "react";
import type { SVGProps } from "react";
export const SvgNavChampions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M9.997 1.667A8.333 8.333 0 0 1 18.331 10v3.137a1.666 1.666 0 0 1-.922 1.49l-2.412 1.206v.834a2.5 2.5 0 0 1-2.353 2.495l-.188.005c.018-.091.03-.183.036-.275l.005-.142v-.417a1.667 1.667 0 0 0-1.541-1.662l-.125-.004H9.164a1.667 1.667 0 0 0-1.662 1.541l-.005.125v.417c0 .142.015.282.042.417h-.042a2.5 2.5 0 0 1-2.5-2.5v-.834l-2.411-1.206a1.667 1.667 0 0 1-.922-1.491V10a8.333 8.333 0 0 1 8.333-8.333Zm-3.333 7.5a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Zm6.667 0a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Z"
    />
  </svg>
);
